'use strict';

var _redux = require('redux');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactRedux = require('react-redux');

var _reducer = require('./reducer');

var _reducer2 = _interopRequireDefault(_reducer);

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _page = require('./page');

var _page2 = _interopRequireDefault(_page);

require('antd/dist/antd.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Store = (0, _redux.createStore)(_reducer2.default, (0, _redux.applyMiddleware)(_reduxThunk2.default));

var mainRender = function mainRender() {
  (0, _reactDom.render)(_react2.default.createElement(
    _reactRedux.Provider,
    { store: Store },
    _react2.default.createElement(_page2.default, null)
  ), document.querySelector('#app'));
};

mainRender();


//////////////////
// WEBPACK FOOTER
// ./src/app.js
// module id = 152
// module chunks = 0